import {StackPropsBase} from "tamagui";

export type LmYoutubeEmbedProps = StackPropsBase & {
    youtubeId: string
}